import { Injectable } from "@angular/core";
import { UTCDate } from "@ankaadia/ankaadia-shared";
import { reportProgress } from "@ankaadia/ankaadia-shared-frontend";
import {
    ExcelAddInDto,
    GetAvailableOrganizationsGQL,
    GetLingokingDataGQL,
    LingokingTableType,
    OrganizationListDto,
} from "@ankaadia/graphql";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class LingokingDataService {
  constructor(
    private readonly getAvailableOrganizationsQuery: GetAvailableOrganizationsGQL,
    private readonly getLingokingDataQuery: GetLingokingDataGQL
  ) {}

  getOrganizationData(): Observable<OrganizationListDto> {
    return this.getAvailableOrganizationsQuery.subscribe().pipe(
      map((result: any) => result.data.getAvailableOrganizations),
      reportProgress("getAvailableOrganizations", "1", false, { silent: true })
    );
  }

  getLingokingData(
    language: string,
    fromDate: UTCDate,
    toDate: UTCDate,
    tables: LingokingTableType[],
    organizationIds: string[]
  ): Observable<ExcelAddInDto> {
    return this.getLingokingDataQuery
      .subscribe({
        input: {
          language: language,
          fromDate: fromDate,
          toDate: toDate,
          organizationIds: organizationIds,
          tables: tables,
        },
      })
      .pipe(
        map((result: any) => result.data.getLingokingData),
        reportProgress("getLingokingData", "1", false, { silent: true })
      );
  }
}
